<template>
    <div id="ctWrap" >
        <div class="spacer-50 pc-mode"></div>
        <div class="spacer-40 mb-mode"></div>
        <div class="login-top-box">
            <a href="" class="btn-logo"><img src="/img/common/logo.png"></a>
        </div>
        <div class="spacer-30 pc-mode"></div>
        <div class="xrp-box-s" >
            <div class="xrp-txt-s" v-if="this.isAuthenticated" ><span>ID : </span>{{ this.user.mem_uuid }}</div>
            <!--<div class="xrp-txt-s" v-if="this.isAuthenticated" ><span>EMAIL : </span>{{ this.user.email }}</div>-->
            <div class="xrp-txt-s" v-if="this.isAuthenticated" ><span>XRP Wallet : </span>{{ this.user.xrp_wallet }}</div>
            <div class="xrp-box-in">
                <img src="/img/common/icon03.svg">
                <p>{{this.user.name }}<br/>
                    <b>{{this.user.email }} </b></p>
            </div>
            <div class="xrp-box-in">
                <img src="/img/common/icon04.svg">
                <p>Reinvestment<br/>
                    Amount<br/>
                    {{this.detail.reinvestment_amount}} XRP</p>
            </div>
            <div class="xrp-box-in">
                <img src="/img/common/icon01.svg">
                <p>Total Package Income<br/>
                    Amount<br/>
                    {{this.detail.total_deposit}} XRP</p>
            </div>
            <div class="xrp-box-in">
                <img src="/img/common/icon06.svg">
                <p>Withdrawable<br/>
                    Amount<br/>
                    {{this.detail.total_balance}} XRP</p>
            </div>
            <div class="xrp-box-in">
                <img src="/img/common/icon02.svg">
                <p>Withdrawal<br/>
                    Amount<br/>
                    {{this.detail.total_withdrawal}} XRP</p>
            </div>
            <div class="xrp-box-in">
                <img src="/img/common/icon05.svg">
                <p>Referral<br/>
                    Amount<br/>
                    {{this.detail.total_referral}} XRP</p>
            </div>

        </div>
        <div class="spacer-80 pc-mode"></div>
        <div class="spacer-40 mb-mode"></div>
        <div class="main-title pc-mode">Wallet XRP Transfer</div>
        <div class="main-title mb-mode">Wallet XRP Transfer</div>
        <div class="pd-box2">
            <div class="pd-input-zone">
                <div class="pd-input-zone-left">
                    <p>Your Wallet Balance XRP</p>
                    <input type="text" name="wallet_balance" id="wallet_balance" class="form-control input-readonly" v-model="wallet_balance" readonly>
                </div>
                <div class="pd-input-zone-right">
                    <p>XRP Amount</p>
                    <input type="number" name="target_tranfer_xrp" id="target_tranfer_xrp" class="form-control" pattern="[0-9]+" min="0" v-model="target_tranfer_xrp"
                           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                           @input="targetTransferChangeFunc($event)">
                </div>
            </div>
            <div class="pd-input-zone">
                <div class="pd-input-zone-w">
                    <p>XRP Wallet Address</p>
                    <input type="text" name="wallet_address" id="wallet_address" class="form-control" v-model="wallet_address">
                    <div class="spacer-50 pc-mode"></div>
                    <div class="spacer-30 mb-mode"></div>
                    <p>Destination Tag (Optional)</p>
                    <input type="text" name="destination_tag" id="destination_tag" class="form-control" v-model="destination_tag">
                </div>
            </div>
            <div class="pd-box-txt">
                When sending a remittance to an address that exists on the exchange, you must<br/>
                enter the Destination Tag to complete the normal deposit to the user's account.
            </div>
            <div class="m-btn">
                <!-- 출금처리중에는 spinner가 보이고 버튼 클릭이 동작하지 않는다..-->
                <button v-on:click="confirmTransfer" :disabled="isLoading === true">
                    <b-spinner small type="grow" v-if="isLoading"></b-spinner> Submit
                </button>
                <!-- <a> 를 사용하면 모달을 띄울때 창상단으로 스크롤 되어 버린다. 따라서 button을 사용한다.-->
                <!--<a href="#" v-on:click="withdraw" >Submit</a>-->
            </div>
        </div>
        <div class="spacer-40 "></div>
        <div class="part-line"></div>
        <div class="main-title">Wallet Transfer History</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="link-txt">
            <p class="p_size">Total Transfer  : {{total_walletTransfer}} XRP</p>
        </div>
        <div class="spacer-20 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="component" style="position:relative;overflow:auto !important;">
            <table class="normal-tb">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Transaction ID</th>
                    <th>Wallet Address</th>
                    <th>Destination Tag</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(trnsfer, index) in walletTransferList" :key="index" @click="walletTransferInfo(trnsfer.trn_id)">
                    <td>#{{index + 1}}</td>
                    <td class="id-txt">{{trnsfer.tran_tid}}</td>
                    <td>{{trnsfer.target_wallet}} XRP</td>
                    <td>{{trnsfer.target_tag}} XRP</td>
                    <td>{{trnsfer.transfer_amt}} XRP</td>
                    <td>{{trnsfer.status}} </td>
                    <td>{{trnsfer.regist_at}} </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer-30"></div>
        <div class="m-btn">
            <a href="" class="s-btn" onclick="javascript:return false;" v-on:click="walletTransferMore" >+ More</a>
        </div>
        <div class="spacer-80 pc-mode"></div>
        <div class="spacer-40 mb-mode"></div>
        <div class="main-title pc-mode">Your Condition(Withdrawal/Reinvestment)</div>
        <div class="main-title mb-mode">Your Condition<br/>(Withdrawal/Reinvestment)</div>

        <div class="xrp-box-w">
            <div class="xrp-box-in">
                <img src="/img/common/icon02.svg">
                <p>Withdrawal<br/><span>{{this.detail.withdraw_rate}}% XRP</span></p>
            </div>
            <div class="xrp-box-in">
                <img src="/img/common/icon04.svg">
                <p>Reinvestment<br/><span>{{this.detail.reinvest_rate}}% XRP</span></p>
            </div>
        </div>
        <div class="spacer-80 pc-mode"></div>
        <div class="spacer-40 mb-mode"></div>
        <div class="part-line"></div>
        <div class="main-title">Package Join History</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="link-txt">
            <p class="p_size">Total Income : {{this.detail.total_deposit}} XRP</p>
        </div>
        <div class="spacer-20 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="component" style="position:relative;overflow:auto;">
            <table class="normal-tb">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Wallet Address</th>
                    <th>Income XRP</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="income in incomeList" :key="income.rownum">
                    <td>#{{income.rownum}}</td>
                    <td class="id-txt">{{ user.xrp_wallet }}</td>
                    <td>{{income.income_amt}} XRP</td>
                    <td>{{income.regist_at}} </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer-40 "></div>
        <div class="part-line"></div>
        <div class="main-title">Withdrawal Request History</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="link-txt">
            <p class="p_size">Total Withdrawal  : {{total_withdrawal_request}} XRP</p>
        </div>
        <div class="spacer-20 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="component" style="position:relative;overflow:auto !important;">
            <table class="normal-tb rowclick-tb">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Wallet</th>
                    <th>Amount From</th>
                    <th>Withdrawal Amount</th>
                    <th>Reinvestment Amount</th>
                    <th>Transfer Fee</th>
                    <th>Status</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(withdraw, index) in withdrawRequestList" :key="index" @click="withdrawalHistoryInfo(withdraw.wit_id)">
                    <td>#{{index + 1}}</td>
                    <td class="id-txt">{{withdraw.xrp_wallet}}</td>
                    <td>{{withdraw.withdrawal_amt}} XRP</td>
                    <td>{{withdraw.transfer_amt}} XRP</td>
                    <td>{{withdraw.reinvest_amt}} XRP</td>
                    <td>{{withdraw.company_fee}} XRP</td>
                    <td>{{withdraw.status}}</td>
                    <td>{{withdraw.regist_at}} </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer-30"></div>
        <div class="m-btn">
            <a href="" class="s-btn" onclick="javascript:return false;" v-on:click="withdrawalHistoryMore" >+ More</a>
        </div>
        <div class="spacer-40 "></div>
        <div class="part-line"></div>
        <div class="main-title">Withdrawal Complete History</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="link-txt">
            <p class="p_size">Total Withdrawal  : {{total_withdrawal}} XRP</p>
        </div>
        <div class="spacer-20 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="component" style="position:relative;overflow:auto !important;">
            <table class="normal-tb">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Transaction ID</th>
                    <th>Amount From</th>
                    <th>Withdrawal Amount</th>
                    <th>Reinvestment Amount</th>
                    <th>Transfer Fee</th>
                    <th>Status</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(withdraw, index) in withdrawList" :key="index">
                    <td>#{{index + 1}}</td>
                    <td class="id-txt">{{withdraw.tran_tid}}</td>
                    <td>{{withdraw.xrp_total_amt}} XRP</td>
                    <td>{{withdraw.transfer_amt}} XRP</td>
                    <td>{{withdraw.reinvest_amt}} XRP</td>
                    <td>{{withdraw.company_fee}} XRP</td>
                    <td>{{withdraw.status}} </td>
                    <td>{{withdraw.regist_at}} </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer-30"></div>
        <div class="m-btn">
            <a href="" class="s-btn" onclick="javascript:return false;" v-on:click="withdrawalMore" >+ More</a>
        </div>
        <div class="spacer-40"></div>
        <div class="part-line"></div>
        <div class="main-title">Referral History</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="link-txt">
            <p class="p_size">Total Referral Income : {{this.total_referral_income}} XRP</p>
        </div>
        <div class="spacer-20 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="component" style="position:relative;overflow:auto;">
            <table class="normal-tb rowclick-tb">
                <thead>
                <tr>
                    <th>#</th>
                    <th>User ID</th>
                    <th>Income XRP</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(referral, index) in referralList" :key="index" v-on:click="showPersonDetail(referral.mem_uuid)">
                    <td>#{{index + 1}}</td>
                    <td class="id-txt">{{referral.mem_uuid}}</td>
                    <td>{{referral.income_amt}} XRP</td>
                    <td>{{referral.regist_at}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer-30"></div>
        <div class="m-btn">
            <a href="" class="s-btn" onclick="javascript:return false;" v-on:click="referralIncomeMore" >+ More</a>
        </div>

        <div class="spacer-40"></div>
        <div class="part-line"></div>
        <div class="main-title">Buy XRP History</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="link-txt">

        </div>
        <div class="spacer-20 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="component" style="position:relative;overflow:auto;">
            <table class="normal-tb">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Wallet Address</th>
                    <th>XRP Amount</th>
                    <th>Transfer Money</th>
                    <th>Currency</th>
                    <th>Account</th>
                    <th>Status</th>
                    <th>Err Msg</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(buy, index) in buyXrpList" :key="index">
                    <td>#{{index + 1}}</td>
                    <td class="id-txt">{{buy.receive_wallet}}</td>
                    <td>{{buy.xrp_amount}}</td>
                    <td>{{buy.transfer_money}}</td>
                    <td>{{buy.currency_type}}</td>
                    <td>{{buy.account}}</td>
                    <td>{{buy.status}}</td>
                    <td>{{buy.error}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer-30"></div>
        <div class="m-btn">
            <a href="" class="s-btn" onclick="javascript:return false;" v-on:click="buyXrpMore" >+ More</a>
        </div>

        <div class="spacer-40"></div>
        <div class="part-line"></div>
        <div class="main-title">1:1 Inquiry</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="pd-box-txt" style="padding: 0 0;">
            When applying for withdrawal, please check your wallet address and destination tag and enter it.<br/>
            (If there's no destination Tag (optimal), don't write anything in the destination tag column)
        </div>
        <div class="pd-box-txt" style="padding: 10px 0;">
            If there is an error in the withdrawal address, the withdrawal application will be canceled.<br/>
            If the deposit is not made after applying for withdrawal, please check your withdrawable (XRP) once again.<br/>
            (If it's canceled, the amount of application will be restored)
        </div>
        <div class="link-txt">
            <!--<p class="p_size">Write</p>-->
            <p class="p_size">
            <a href="" class="s-btn" onclick="javascript:return false;" v-on:click="writeInquiry" >Write</a>
            </p>
        </div>
        <div class="spacer-20 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="component" style="position:relative;">
            <table class="normal-tb rowclick-tb">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>State</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(inquiry, index) in inquiryList" :key="index" v-on:click="showInquiry(inquiry)">
                    <td>#{{index + 1}}</td>
                    <td class="id-txt">{{inquiry.title}}</td>
                    <td>{{inquiry.status}} </td>
                    <td>{{inquiry.regist_at}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer-30"></div>
        <div class="m-btn">
            <a href="" class="s-btn" onclick="javascript:return false;" v-on:click="inquiryListMore" >+ More</a>
        </div>
        <!-- Modals -->
        <div class="row">
            <modal :show.sync="modals.inquiryShow"
                   modal-classes="modal-inquiry modal-lg modal-dialog-centered modal-title-notification" size="lg">
                <template slot="header">
                    <h4 class="modal-title" id="modal-inquiry" style="color:white;font-weight: bold;">Inquiry Write</h4>
                </template>
                <div class="row">
                    <div class="col-sm-12">
                        <input type="text" id="inquiry_title" v-model="inquiry_title" placeholder="Title" class="form-control inquiry_control">
                    </div>
                </div>
                <div class="spacer-10"></div>
                <div class="row">
                    <div class="col-sm-12">
                        <textarea rows="5" id="inquiry_content" v-model="inquiry_content"  placeholder="Inquiry" class="form-control inquiry_control"></textarea>
                    </div>
                </div>
                <div class="spacer-40"></div>
                <div>
                    <base-button type="secondary"
                                 class="inquiry_button"
                                 @click="submitInquiry">
                        Submit
                    </base-button>
                    <base-button type="primary"
                                 class="inquiry_button"
                                 @click="closeInquiry">
                        Close
                    </base-button>
                </div>
            </modal>
            <modal :show.sync="modals.inquiryViewShow"
                   modal-classes="modal-inquiry modal-lg modal-dialog-centered modal-title-notification" size="lg">
                <template slot="header">
                    <h4 class="modal-title" id="modal-inquiry" style="color:white;font-weight: bold;">Inquiry View</h4>
                </template>
                <table class="normal-tb">
                    <tr>
                        <th>Title</th>
                        <td class="text-left"><span class="inquiry_cont" >{{ v_inquiry_title }}</span></td>
                    </tr>
                    <tr>
                        <th>Inquiry</th>
                        <td class="text-left"><span class="inquiry_cont" v-html="v_inquiry_content"></span></td>
                    </tr>
                    <tr>
                        <th>Answer</th>
                        <td class="text-left"><span class="inquiry_cont" v-html="v_inquiry_answer"></span></td>
                    </tr>
                    <tr>
                        <th>Date</th>
                        <td class="text-left"><span class="inquiry_cont"> {{v_inquiry_date}} </span></td>
                    </tr>
                </table>
                <div class="spacer-40"></div>
                <div>
                    <base-button type="primary"
                                 class="inquiry_button"
                                 @click="modals.inquiryViewShow = false">
                        Close
                    </base-button>
                </div>
            </modal>
            <modal :show.sync="modals.notificationShow"
                   gradient="danger"
                   modal-classes="modal-warning modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4">{{ notificationMessage }}</h4>
                </div>

                <template slot="footer">
                    <!--<base-button type="white">Ok, Got it</base-button>-->
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.notificationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="modals.info"
                   modal-classes="modal-info modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-confirmation">Success!</h6>
                <p>
                    {{ infoMessage }}
                </p>
                <p>
                    {{ infoSubMessage }}
                </p>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.info = false"
                    >Close</base-button>
                </template>
            </modal>
            <modal :show.sync="modals.confirmationShow"
                   modal-classes="modal-info modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-confirmation">Your confirmation is required</h6>

                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4">{{ confirmationMessage }}</h4>
                </div>

                <template slot="footer">
                    <base-button type="white" class="modal-confirm-btn"
                                 v-on:click="transferXrp">Ok, Got it</base-button>
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.confirmationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="modals.personal"
                   modal-classes="modal-detail modal-dialog-centered ">
                <p>User ID : {{ this.mem_uuid }}</p>
                <div class="spacer-10"></div>
                <div class="body-normal">
                    <div class="pop-id-box">
                        <div class="pop-id-box-in">
                            <div>
                                Total Package Income<br/>
                                Amount<br/>
                                {{this.personDetail.total_deposit}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Withdrawal<br/>
                                Amount<br/>
                                {{this.personDetail.total_withdrawal}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Reinvestment<br/>
                                Amount<br/>
                                {{this.personDetail.reinvestment_amount}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Referral<br/>
                                Amount<br/>
                                {{this.personDetail.total_referral}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Upline<br/>
                                Amount<br/>
                                {{this.personDetail.upline_income}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Downline<br/>
                                Amount<br/>
                                {{this.personDetail.downline_income}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Withdrawable<br/>
                                Amount<br/>
                                {{this.personDetail.total_balance}} XRP
                            </div>
                        </div>
                        <!--<div class="pop-id-box-in">
                            <div>
                                Registration NO<br/>
                                #{{this.personDetail.mem_level}}
                            </div>
                        </div>-->
                    </div>
                </div>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.personal = false"
                    >Close</base-button>
                </template>
            </modal>
            <modal :show.sync="modals.withdrawReqShow"
                   modal-classes="modal-detail modal-dialog-centered ">
                <p>Wallet : {{ this.withdrawReqInfo.xrp_wallet }}</p>
                <div class="spacer-10"></div>
                <div class="body-normal">
                    <div class="pop-id-box">
                        <div class="pop-id-box-in">
                            <div>
                                Amount From<br/>
                                {{this.withdrawReqInfo.withdrawal_amt}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Status<br/>
                                {{this.withdrawReqInfo.status}}
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Regist Date<br/>
                                {{this.withdrawReqInfo.regist_at}}
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                <span v-if="this.withdrawReqInfo.status === 'finish'">Transfer Date<br/></span>
                                <span v-else>Cancel Date<br/></span>
                                {{this.withdrawReqInfo.update_at}}
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Error/Cancel Message<br/>
                                <center>
                                <span v-if="!this.withdrawReqInfo.error">-</span>
                                <div style="background-color: #eb8934;padding: 5px;" v-else>{{this.withdrawReqInfo.error}}</div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.withdrawReqShow = false"
                    >Close</base-button>
                </template>
            </modal>
            <modal :show.sync="modals.transferInfoShow"
                   modal-classes="modal-detail modal-dialog-centered ">
                <p>Wallet : {{ this.transferInfo.target_wallet }} / {{this.transferInfo.target_tag}}</p>
                <div class="spacer-10"></div>
                <div class="body-normal">
                    <div class="pop-id-box">
                        <div class="pop-id-box-in">
                            <div>
                                Amount<br/>
                                {{this.transferInfo.transfer_amt}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Status<br/>
                                {{this.transferInfo.status}}
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Regist Date<br/>
                                {{this.transferInfo.regist_at}}
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                <span v-if="this.transferInfo.status === 'ok'">Transfer Date<br/></span>
                                <span v-else>Fail Date<br/></span>
                                {{this.transferInfo.regist_at}}
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Error Message<br/>
                                <center>
                                <span v-if="!this.transferInfo.error">-</span>
                                <div style="background-color: #eb8934;padding: 5px;" v-else>{{this.transferInfo.error}}</div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.transferInfoShow = false"
                    >Close</base-button>
                </template>
            </modal>
        </div>
    </div>
</template>
<style>
    .p_size {
        font-size: 20px !important;
    }
    .modal-detail p {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
    }
    .modal-inquiry {
        text-align:center;
    }
    .modal-inquiry > .modal-content {
        background-color: #6097e6 !important;
    }
    .inquiry_control {
        padding: 5px 5px 5px 5px !important;
        font-size: 18px !important;
    }
    .inquiry_button {
        border-radius: 5px !important;
    }
    .inquiry_view {
        font-weight: bold;
        font-size : 18px;
        color : #fff;
    }
    .inquiry_cont {
        font-size : 16px;
        color : #fff;
    }

</style>
<script>
import Modal from "@/components/Modal.vue";
import axios from '../service/axios'
import {mapGetters} from "vuex";
export default {
    components: {
        Modal
    },
    data: () =>{
        return {
            isLoading: false,
            mem_uuid : '',
            personDetail : {},
            withdrawReqInfo : {},
            transferInfo : {},
            incomeList: [],
            withdrawRequestList : [],
            withdrawList : [],
            referralList : [],
            buyXrpList : [],
            inquiryList : [],
            walletTransferList: [],
            total_walletTransfer : 0,
            total_withdrawal_request : 0,
            total_withdrawal : 0 ,
            total_referral_income : 0 ,
            target_tranfer_xrp:0,
            wallet_address:'',
            destination_tag:'',
            confirmationMessage : '',
            notificationMessage : '',
            infoMessage: '',
            infoSubMessage: '',
            inquiry_title: '',
            inquiry_content: '',
            v_inquiry_title: '',
            v_inquiry_content: '',
            v_inquiry_answer: '',
            v_inquiry_date: '',
            modals: {
                personal: false,
                info: false,
                confirmationShow: false,
                notificationShow: false,
                inquiryShow : false,
                inquiryViewShow : false,
                withdrawReqShow : false,
                transferInfoShow : false
            },
        }
    },
    computed: {
        ...mapGetters(["isAuthenticated"]),
        ...mapGetters(["detail"]),  /* store에 저장된 값을 가져온다. */
        ...mapGetters(["user"]),
        wallet_balance: function() {
            if (this.isAuthenticated) {
                return this.getSafeFloat(this.detail.xrp_balance);
            } else {
                return "";
            }
        }
    },
    watch: {
        '$store.state.isAuthenticated': function() {
            // state에서 상태변화를 모니터링 한다.
            if (!this.isAuthenticated) {
                // 로그아웃으로 변화했다.
                this.incomeList = [];
                this.withdrawRequestList = [];
                this.withdrawReqInfo = {};
                this.withdrawList = [];
                this.referralList = [];
                this.buyXrpList = [];
                this.inquiryList = [];
                this.walletTransferList = [];
                this.total_withdrawal_request = 0;
                this.total_withdrawal = 0;
                this.total_referral_income = 0;
                this.total_walletTransfer = 0;
                this.wallet_balance = 0;
                this.target_tranfer_xrp = 0;
                this.wallet_address = '';
                this.destination_tag = '';
            }
        }
    },
    mounted() {
        $("#app").removeClass('main');
        $("#gnb").hide(); // 메인의 메인링크부분을 숨긴다.
        this.$store.dispatch("setDetail");
        this.incomeListMore();
        this.withdrawalHistoryMore();
        this.withdrawalMore();
        this.referralIncomeMore();
        this.buyXrpMore();
        this.inquiryListMore();
        this.walletTransferMore();
    },
    methods : {
        getSafeFloat : function(value) {
            let strVal = value + '';
            strVal = strVal.replace(/,/g, '');
            return Number.parseFloat(strVal);
        },
        targetTransferChangeFunc(event){
            if (!this.isAuthenticated) {
                return;
            }
        },
        confirmTransfer:function() {
            if (!this.isAuthenticated) {
                this.notificationMessage = "You are not logged in. Please log in and try again.";
                this.modals.notificationShow = true;
                return false;
            }
            if (this.getSafeFloat(this.target_tranfer_xrp) <= 0) {
                this.notificationMessage = "Please, Enter transfer xrp amount.";
                this.modals.notificationShow = true;
                return false;
            }
            if (this.wallet_balance < this.getSafeFloat(this.target_tranfer_xrp)) {
                this.notificationMessage = "The transfer xrp amount must be at least " + this.wallet_balance + " XRP.";
                this.modals.notificationShow = true;
                return;
            }
            const remainder = this.wallet_balance - this.getSafeFloat(this.target_tranfer_xrp);
            //console.log("remainder = " + remainder);
            if (remainder < 0) {
                this.notificationMessage = "The transfer amount has exceeded.";
                this.modals.notificationShow = true;
                return false;
            }
            if (!this.wallet_address) {
                this.notificationMessage = "Please, Enter traget XRP wallet address.";
                this.modals.notificationShow = true;
                return false;
            }
            this.confirmationMessage = 'Will you proceed the tranfer xrp';
            this.modals.confirmationShow = true;
            /*if (!this.destination_tag) {
                this.notificationMessage = "Please, your wallet destination_tag.";
                this.modals.notificationShow = true;
                return false;
            }*/
        },
        transferXrp:function(){
            this.modals.confirmationShow = false;
            this.isLoading = true;
            const data = {
                tranfer_xrp : this.target_tranfer_xrp,
                wallet_address: this.wallet_address,
                destination_tag: this.destination_tag,
            };
            if (this.isAuthenticated) {
                // JWT-Token Expired check
                axios
                    .post("/auth/v1/verifyToken")
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                    });
                axios
                    .post("/xrp/v1/transfer", data)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.data.status === 'f') {
                                this.notificationMessage = response.data.message;
                                this.modals.notificationShow = true;
                            } else {
                                // 송금성공했으니, 송금요청 금액 정보는 지워주자.
                                this.target_tranfer_xrp = 0;
                                this.infoMessage = 'The transfer request was successful.';
                                this.infoSubMessage = "TX-KEY : " + response.data.tx_hash;
                                this.modals.info = true;

                                this.$store.dispatch("setDetail");
                            }
                        }
                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error)
                        this.isLoading = false;
                    });
            }
        },
        showPersonDetail : function (mem_uuid) {
            if (this.isLoading === true) {
                return;
            }
            this.mem_uuid = mem_uuid;
            this.isLoading = true;
            const data = {
                person_id : mem_uuid,
            };
            if (this.isAuthenticated) {
                // JWT-Token Expired check
                axios
                    .post("/auth/v1/verifyToken")
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                    });
                axios
                    .post("/users/v1/user/detail", data)
                    .then(response => {
                        this.personDetail = response.data;
                        //console.log(this.personDetail);
                        this.modals.personal = true;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response)
                        this.notificationMessage = 'Fail to get detail information.';
                        this.modals.notificationShow = true;
                        this.isLoading = false;
                    });
            }
        },
        incomeListMore : function () {
            axios
                .post("/users/v1/deposit/income/list")
                .then(response => {
                    if (response.status === 200) {
                        this.incomeList = response.data;
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        withdrawalHistoryInfo : function (wit_id) {
            const data = {
                wit_id : wit_id,
            }
            axios
                .post("/users/v1/withdraw_request/info", data)
                .then(response => {
                    if (response.status === 200) {
                        //console.log(response.data)
                        this.withdrawReqInfo = response.data;
                        this.modals.withdrawReqShow = true;
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        withdrawalHistoryMore : function () {
            const data = {
                offset : this.withdrawRequestList.length,
                limit : 10
            }
            axios
                .post("/users/v1/withdraw_request/list", data)
                .then(response => {
                    if (response.status === 200) {
                        //console.log(response.data)
                        const fList = response.data;
                        let twd= 0
                        /*fList.forEach(function(element){
                            twd += parseFloat(element.transfer_amt);
                        });*/
                        for (let idx = 0 ; idx < fList.length; idx++) {
                            let element = fList[idx];
                            twd += this.getSafeFloat(element.withdrawal_amt);
                        }
                        this.total_withdrawal_request += this.getSafeFloat(twd);
                        if (fList.length > 0) {
                            this.withdrawRequestList.push(...fList);
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        walletTransferInfo : function (trn_id) {
            const data = {
                trn_id : trn_id,
            }
            axios
                .post("/users/v1/transfer/info", data)
                .then(response => {
                    if (response.status === 200) {
                        //console.log(response.data)
                        this.transferInfo = response.data;
                        this.modals.transferInfoShow = true;
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        walletTransferMore : function () {
            const data = {
                offset : this.walletTransferList.length,
                limit : 10
            }
            axios
                .post("/users/v1/transfer/list", data)
                .then(response => {
                    if (response.status === 200) {
                        //console.log(response.data)
                        const fList = response.data;
                        let twd= 0
                        /*fList.forEach(function(element){
                            twd += parseFloat(element.xrp_total_amt);
                        });*/
                        for (let idx = 0 ; idx < fList.length; idx++) {
                            let element = fList[idx];
                            twd += this.getSafeFloat(element.transfer_amt);
                        }
                        this.total_walletTransfer += this.getSafeFloat(twd);
                        if (fList.length > 0) {
                            this.walletTransferList.push(...fList);
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        withdrawalMore : function () {
            const data = {
                offset : this.withdrawList.length,
                limit : 10
            }
            axios
                .post("/users/v1/withdraw/list", data)
                .then(response => {
                    if (response.status === 200) {
                        //console.log(response.data)
                        const fList = response.data;
                        let twd= 0
                        /*fList.forEach(function(element){
                            twd += parseFloat(element.xrp_total_amt);
                        });*/
                        for (let idx = 0 ; idx < fList.length; idx++) {
                            let element = fList[idx];
                            twd += this.getSafeFloat(element.xrp_total_amt);
                        }
                        this.total_withdrawal += this.getSafeFloat(twd);
                        if (fList.length > 0) {
                            this.withdrawList.push(...fList);
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        referralIncomeMore: function () {
            if (!this.isAuthenticated) {
                return;
            }
            const data = {
                offset : this.referralList.length,
                limit : 10
            }
            //console.log(data);
            axios
                .post("/users/v1/referral/income/list", data)
                .then(response => {
                    //console.log(response)
                    if (response.status === 200) {
                        //console.log(response.data)
                        const fList = response.data;
                        let ticm = 0.0;
                        for (let idx = 0 ; idx < fList.length; idx++) {
                            let element = fList[idx];
                            ticm += this.getSafeFloat(element.income_amt);
                        }
                        this.total_referral_income += this.getSafeFloat(ticm);
                        if (fList.length > 0) {
                            this.referralList.push(...fList);
                        }

                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        buyXrpMore: function () {
            if (!this.isAuthenticated) {
                return;
            }
            const data = {
                offset : this.buyXrpList.length,
                limit : 10
            }
            axios
                .post("/users/v1/buyxrp/list", data)
                .then(response => {
                    //console.log(response)
                    if (response.status === 200) {
                        //console.log(response.data)
                        const fList = response.data;
                        if (fList.length > 0) {
                            this.buyXrpList.push(...fList);
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        inquiryListMore: function () {
            if (!this.isAuthenticated) {
                return;
            }
            const data = {
                offset : this.inquiryList.length,
                limit : 10
            }
            //console.log(data);
            axios
                .post("/users/v1/inquiry/list", data)
                .then(response => {
                    //console.log(response)
                    if (response.status === 200) {
                        //console.log(response.data)
                        const fList = response.data;
                        if (fList.length > 0) {
                            this.inquiryList.push(...fList);
                        }

                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        writeInquiry: function () {
            this.inquiry_title = '';
            this.inquiry_content = '';
            this.modals.inquiryShow = true;
        },
        showInquiry: function (inquiry) {



            this.v_inquiry_title = inquiry.title ;
            this.v_inquiry_content = inquiry.content.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.v_inquiry_answer = inquiry.answer ;
            this.v_inquiry_date = inquiry.regist_at ;
            this.modals.inquiryViewShow = true;
        },
        closeInquiry(evt) {
            this.modals.inquiryShow = false;
            this.inquiry_title = '';
            this.inquiry_content = '';
        },
        submitInquiry (evt) {
            if (!this.inquiry_title) {
                return;
            }
            if (!this.inquiry_content) {
                return;
            }

            const data = {
                inquiry_title : this.inquiry_title,
                inquiry_content : this.inquiry_content,
            }
            axios
                .post("/users/v1/inquiry/regst", data)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.status === 's') {
                            this.modals.inquiryShow = false;
                            this.inquiry_title = '';
                            this.inquiry_content = '';
                            this.inquiryListMore();
                            alert("THANK YOU FOR YOUR SUBMISSION!");
                        } else {
                            alert(response.data.message);
                        }
                    } else {
                        alert("Error");
                    }
                })
                .catch(error => {
                    console.log(error)
                    alert(error);
                })
        }
    }
};
</script>
<style>
</style>
